/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { Link } from "@quintype/components";
import { array, string, bool } from "prop-types";
import atob from "atob";
import { Base64 } from "js-base64";

import Headline from "../../atoms/headline";
import SmallHorizontalCard from "../../molecules/small-horizontal-card";

import "./sidebar.m.css";
import Adsense, { AdsenseSideBar } from "../../adsense";
import DfpAd from "../../dfp-ad";

class SideBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null,
      jsEmbed: `<script src='https://www.googletagservices.com/tag/js/gpt.js'>
      googletag.pubads().definePassback('/21751243814/Freepressjournal_300x250_DT_MWeb_Global_STMA', [300, 250]).display();
    </script>`
    };
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  getScript = () => {
    const jsEmbed = `<script src='https://www.googletagservices.com/tag/js/gpt.js'>
    googletag.pubads().definePassback('/21751243814/Freepressjournal_300x250_DT_MWeb_Global_STMA', [300, 250]).display();
  </script>`;
    this.setState({ jsEmbed });
  };

  componentDidMount() {
    this.isWidthPresent();
    this.getScript();
  }

  getEmbedJS() {
    var embedjs = Base64.encode(this.state.jsEmbed);
    return embedjs != null ? atob(embedjs) : null;
  }

  render() {
    const { stories, collectionName, id = "", liveBlog } = this.props;
    const filteredStories =
      stories &&
      stories.length > 0 &&
      stories.filter(item => item.story.id !== id && item.story["story-template"] !== "horoscope");
    // const adsId1 = "8314659081";
    // const adsId2 = "1964873157";

    return (
      <React.Fragment>
        {!liveBlog &&
          this.state.width >= 992 && (
            <React.Fragment>
              <div styleName="dfp-ad-300x250">
                <Adsense adSlotId="3689255812" width="300" height="250" />
              </div>
            </React.Fragment>
          )}
        {this.state.width <= 992 && (
          <div styleName="dfp-ad-300x250">
            <AdsenseSideBar adSlotId="5412947508/6889655388" width="300" height="250" />
          </div>
        )}
        {liveBlog && (
          <div styleName="dfp-ad-300x250">
            <Adsense adSlotId="3689255812" width="300" height="250" />
          </div>
        )}
        {stories && stories.length > 0 ? (
          <div styleName="wrapper">
            {collectionName && filteredStories.length > 0 ? (
              <div styleName="collection-name">
                <Headline text={collectionName} headerType={13} headerLevel={3} />
              </div>
            ) : null}
            {filteredStories.map((item, index) => (
              <Link href={`/${item.story.slug}`} key={index}>
                <SmallHorizontalCard story={item.story} key={index} />
              </Link>
            ))}
          </div>
        ) : null}
        <div styleName="dfp-ad-300x250">
          <DfpAd adtype="Freepressjournal_300x250_DT_MWeb_Global_STMA" dfpNetworkId="21751243814" />
        </div>
        {this.state.width >= 992 && <AdsenseSideBar adSlotId="5412947508/6749902668" width="300" height="600" />}
      </React.Fragment>
    );
  }
}

SideBar.propTypes = {
  stories: array,
  collectionName: string,
  id: string,
  liveBlog: bool
};

export default SideBar;
